import { ApiBase } from 'api/api'
import { makeGetRequest } from 'api/fetchCalls'
import type { ReminderProps } from 'types/reminders'

type FilterParamsKeyType = 'form' | 'document' | 'packet'

export type FilterParamsModel = Record<FilterParamsKeyType, string>

export async function loadReminderById(
  params: FilterParamsModel
): Promise<ReminderProps[]> {
  return makeGetRequest(`${ApiBase}/reminders/`, {
    params,
  })
}
